import { render, staticRenderFns } from "./HealthBand.vue?vue&type=template&id=9309543a"
import script from "./HealthBand.vue?vue&type=script&lang=js"
export * from "./HealthBand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports